export default __webpack_public_path__ + "static/media/estafeta-logo.dfc788b9.png";